"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.Timer = void 0;
var tslib_1 = require("tslib");
var Timer = /** @class */ (function () {
    function Timer(timeIntervalInMs) {
        this.timeOutFlag = false;
        this.timeIntervalInMs = timeIntervalInMs;
    }
    Timer.prototype.start = function () {
        var _this = this;
        this.timeOutFlag = false;
        this.timeoutId = setTimeout(function () {
            _this.timeOutFlag = true;
            clearTimeout(_this.timeoutId);
        }, this.timeIntervalInMs);
    };
    Timer.prototype.hasTimeoutExpired = function () {
        return this.timeOutFlag;
    };
    Timer.prototype.stop = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    };
    return Timer;
}());
exports.Timer = Timer;
var delay = function (timeIntervalInMs) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        if (timeIntervalInMs) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, timeIntervalInMs); })];
        }
        return [2 /*return*/];
    });
}); };
exports.delay = delay;
